import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import styled from 'styled-components';
const Container = styled.button `
  --borderWidth: 2px;

  --bgSize: 100% 100%;
  --colorFg: ${brand.black};
  --colorBg: transparent;
  --colorBorder: ${brand.yellow};

  --bgSizeActive: 0% 100%;
  --colorFgActive: ${brand.black};
  --colorBgActive: ${brand.yellow};
  --colorBorderActive: ${brand.yellow};


  display: inline-flex;
  align-items: center;
  border: var(--borderWidth, 0) solid var(--colorBorder, var(--colorBg));
  background: var(--colorBg);
  background-image: linear-gradient(to right, var(--colorBgActive), var(--colorBgActive));
  background-repeat: no-repeat;
  background-size: var(--bgSize);
  color: var(--colorFg);
  height: 55px;
  padding: 0px 15px;
  text-decoration: none;
  ${transition('background-size, border-color, opacity')};
  user-select: none;
  width: auto;
  height: 100%;
  margin-left: auto;

  &[data-fill='right'] {
    background-position: right center;
  }

  &[data-fill='left'] {
    background-position: left center;
  }

  &[data-button-selected='true'] {
    --colorFg: ${brand.black};
    --colorBg: ${brand.white};
    --colorBorder: ${brand.grey};
    --colorFgActive: ${brand.black};
    --colorBgActive: ${brand.grey};
    --colorBorderActive: ${brand.grey};
  }

  @media ${from(Device.TabletLarge)} {
    &{
      padding: 0 28px;
    }
  }

  span& {
    button:focus &,
    a:focus & {
      outline: auto;
      outline-offset: 3px;
    }    
  }

  &:not(span) {
    cursor: pointer;
    outline: none;
    border:0;

    &.focus-ring {
      outline: auto;
      outline-offset: 5px;
    }   
  }
`;
const Text = styled.span `
  --fontSize: 22px;
  --lineHeight: 21px;

  ${transition('color')};

  color: currentColor;
  ${fonts.altGothicNo2.regular};
  font-size: var(--fontSize);
  line-height: var(--lineHeight);
  text-decoration: none;
  text-transform: uppercase;
  white-space: nowrap;
  margin-top: 1px;

  [data-icon-only='true'] & {
    ${srOnly};
  }

  position: relative; 

  &::after {
    content: '';
    position: absolute;
    bottom: -2px; 
    left: 0;
    width: 0%;
    height: 2px;
    background-color: ${brand.black};
    ${transition('width')};
  }

  ${Container}:hover & {
    &::after {
      width: 100%;
    }
  }

  @media ${until(Device.TabletLarge)} {
      &{
        --fontSize: 18px;
        --lineHeight: 1;
      }
    }
`;
const IconWrapper = styled.div `
  --size: 20px;
  --spacing: 8px;

  display: block;
  color: currentColor;
  height: var(--size);
  margin: 0;
  padding: 0;
  ${transition('color')};
  width: calc(var(--size) + var(--spacing));
  margin-right: auto;
  order: -1;
  padding-right: var(--spacing);

  display: flex;
  align-items: center;
  justify-content: center;

  @media ${from(Device.TabletLarge)} {
    &{
      --size: 22px;
      --spacing: 20px;
    }
  }
`;
const ButtonStyles = {
    Container,
    IconWrapper,
    Text,
};
export default ButtonStyles;
